<template>
  <div
    v-show="p_active"
    class="flexR"><!--:style="[{'width':(mainWidth-195)+'px'},{'height':(mainHeight-120)+'px'}]"-->
    <div class="w60pct z10">
      <div class="w100pct h30cm">
        <div id="mapContain" class="floatL h30cm w100pct"/>
      </div>
    </div>
    <div class="w40pct z10">
      <div id="divRound" class="h8cm w100pct"/>
      <div id="divBar" class="h8cm w100pct"/>
      <div id="divLine" class="h8cm w100pct"/>
    </div>
    <div v-show="bbViewy" class="w60pct z30 bkWhiteS h50pct" style="position:fixed;top:30%;left:30%;" @click="p11_doClk(41)">
      <div class="pd2mm">
        <table class="tbList">
          <thead>
            <tr class="tbListHead">
              <th style="width: 5px;"/>
              <th v-for="item in vColms" :key="item.vkey">{{ item.vlabel }}</th>
            </tr>
          </thead>
          <tbody>
            <!--<tr v-for="(item,idx) in vData[idxPick].data" 这写法ERROR！！！！--->
            <tr v-for="(item,idx) in vDataCity" :key="idx" @dblclick="toPick2(item,idx)" >
              <td>{{ idx+1 }}</td>
              <td v-for="clm in vColms" :key="clm.vkey" :class="item.picked?'tdPick':''">{{ comm.mkTdHtml(item,clm) }}</td>
              <!--<td>{{ item[clm.vkey] }}</td>-->
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import china from '../../../static/GD.json'
import * as echarts from 'echarts'
export default {
  name: 'Chart',
  components: {},
  props: {
    p_active: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      bbCust: localStorage.getItem('bbCust'),
      bbViewy: false,
      vColms: [],
      vData: [],
      vCity: [],
      vDataStat: [],
      vDataCity: [],
      qtyStat: [],
      qtyCity: [],
      qtyModel: [],
      qtyModel2: [[], []],
      colorList: ['#C33531', '#EFE42A', '#64BD3D', '#EE9201', '#29AAE3', '#B74AE5', '#0AAF9F', '#E89589', '#16A085', '#4A235A', '#C39BD3 ', '#F9E79F', '#BA4A00', '#ECF0F1', '#616A6B', '#EAF2F8', '#4A235A', '#3498DB'],

      citys: {
        '海门': [121.15, 31.89],
        '鄂尔多斯': [109.781327, 39.608266],
        '招远': [120.38, 37.35],
        '舟山': [122.207216, 29.985295],
        '齐齐哈尔': [123.97, 47.33],
        '盐城': [120.13, 33.38],
        '赤峰': [118.87, 42.28],
        '青岛': [120.33, 36.07],
        '乳山': [121.52, 36.89],
        '金昌': [102.188043, 38.520089],
        '泉州': [118.58, 24.93],
        '莱西': [120.53, 36.86],
        '日照': [119.46, 35.42],
        '胶南': [119.97, 35.88],
        '南通': [121.05, 32.08],
        '拉萨': [91.11, 29.97],
        '云浮': [112.02, 22.93],
        '梅州': [116.1, 24.55],
        '文登': [122.05, 37.2],
        '上海': [121.48, 31.22],
        '攀枝花': [101.718637, 26.582347],
        '威海': [122.1, 37.5],
        '承德': [117.93, 40.97],
        '厦门': [118.1, 24.46],
        '汕尾': [115.375279, 22.786211],
        '潮州': [116.63, 23.68],
        '丹东': [124.37, 40.13],
        '太仓': [121.1, 31.45],
        '曲靖': [103.79, 25.51],
        '烟台': [121.39, 37.52],
        '福州': [119.3, 26.08],
        '瓦房店': [121.979603, 39.627114],
        '即墨': [120.45, 36.38],
        '抚顺': [123.97, 41.97],
        '玉溪': [102.52, 24.35],
        '张家口': [114.87, 40.82],
        '阳泉': [113.57, 37.85],
        '莱州': [119.942327, 37.177017],
        '湖州': [120.1, 30.86],
        '汕头': [116.69, 23.39],
        '昆山': [120.95, 31.39],
        '宁波': [121.56, 29.86],
        '湛江': [110.359377, 21.270708],
        '揭阳': [116.35, 23.55],
        '荣成': [122.41, 37.16],
        '连云港': [119.16, 34.59],
        '葫芦岛': [120.836932, 40.711052],
        '常熟': [120.74, 31.64],
        '东莞': [113.75, 23.04],
        '河源': [114.68, 23.73],
        '淮安': [119.15, 33.5],
        '泰州': [119.9, 32.49],
        '南宁': [108.33, 22.84],
        '营口': [122.18, 40.65],
        '惠州': [114.4, 23.09],
        '江阴': [120.26, 31.91],
        '蓬莱': [120.75, 37.8],
        '韶关': [113.62, 24.84],
        '嘉峪关': [98.289152, 39.77313],
        '广州': [113.23, 23.16],
        '延安': [109.47, 36.6],
        '太原': [112.53, 37.87],
        '清远': [113.01, 23.7],
        '中山': [113.38, 22.52],
        '昆明': [102.73, 25.04],
        '寿光': [118.73, 36.86],
        '盘锦': [122.070714, 41.119997],
        '长治': [113.08, 36.18],
        '深圳': [114.07, 22.62],
        '珠海': [113.52, 22.3],
        '宿迁': [118.3, 33.96],
        '咸阳': [108.72, 34.36],
        '铜川': [109.11, 35.09],
        '平度': [119.97, 36.77],
        '佛山': [113.11, 23.05],
        '海口': [110.35, 20.02],
        '江门': [113.06, 22.61],
        '章丘': [117.53, 36.72],
        '肇庆': [112.44, 23.05],
        '大连': [121.62, 38.92],
        '临汾': [111.5, 36.08],
        '吴江': [120.63, 31.16],
        '石嘴山': [106.39, 39.04],
        '沈阳': [123.38, 41.8],
        '苏州': [120.62, 31.32],
        '茂名': [110.88, 21.68],
        '嘉兴': [120.76, 30.77],
        '长春': [125.35, 43.88],
        '胶州': [120.03336, 36.264622],
        '银川': [106.27, 38.47],
        '张家港': [120.555821, 31.875428],
        '三门峡': [111.19, 34.76],
        '锦州': [121.15, 41.13],
        '南昌': [115.89, 28.68],
        '柳州': [109.4, 24.33],
        '三亚': [109.511909, 18.252847],
        '自贡': [104.778442, 29.33903],
        '吉林': [126.57, 43.87],
        '阳江': [111.95, 21.85],
        '泸州': [105.39, 28.91],
        '西宁': [101.74, 36.56],
        '宜宾': [104.56, 29.77],
        '呼和浩特': [111.65, 40.82],
        '成都': [104.06, 30.67],
        '大同': [113.3, 40.12],
        '镇江': [119.44, 32.2],
        '桂林': [110.28, 25.29],
        '张家界': [110.479191, 29.117096],
        '宜兴': [119.82, 31.36],
        '北海': [109.12, 21.49],
        '西安': [108.95, 34.27],
        '金坛': [119.56, 31.74],
        '东营': [118.49, 37.46],
        '牡丹江': [129.58, 44.6],
        '遵义': [106.9, 27.7],
        '绍兴': [120.58, 30.01],
        '扬州': [119.42, 32.39],
        '常州': [119.95, 31.79],
        '潍坊': [119.1, 36.62],
        '重庆': [106.54, 29.59],
        '台州': [121.420757, 28.656386],
        '南京': [118.78, 32.04],
        '滨州': [118.03, 37.36],
        '贵阳': [106.71, 26.57],
        '无锡': [120.29, 31.59],
        '本溪': [123.73, 41.3],
        '克拉玛依': [84.77, 45.59],
        '渭南': [109.5, 34.52],
        '马鞍山': [118.48, 31.56],
        '宝鸡': [107.15, 34.38],
        '焦作': [113.21, 35.24],
        '句容': [119.16, 31.95],
        '北京': [116.46, 39.92],
        '徐州': [117.2, 34.26],
        '衡水': [115.72, 37.72],
        '包头': [110, 40.58],
        '绵阳': [104.73, 31.48],
        '乌鲁木齐': [87.68, 43.77],
        '枣庄': [117.57, 34.86],
        '杭州': [120.19, 30.26],
        '淄博': [118.05, 36.78],
        '鞍山': [122.85, 41.12],
        '溧阳': [119.48, 31.43],
        '库尔勒': [86.06, 41.68],
        '安阳': [114.35, 36.1],
        '开封': [114.35, 34.79],
        '济南': [117, 36.65],
        '德阳': [104.37, 31.13],
        '温州': [120.65, 28.01],
        '九江': [115.97, 29.71],
        '邯郸': [114.47, 36.6],
        '临安': [119.72, 30.23],
        '兰州': [103.73, 36.03],
        '沧州': [116.83, 38.33],
        '临沂': [118.35, 35.05],
        '南充': [106.110698, 30.837793],
        '天津': [117.2, 39.13],
        '富阳': [119.95, 30.07],
        '泰安': [117.13, 36.18],
        '诸暨': [120.23, 29.71],
        '郑州': [113.65, 34.76],
        '哈尔滨': [126.63, 45.75],
        '聊城': [115.97, 36.45],
        '芜湖': [118.38, 31.33],
        '唐山': [118.02, 39.63],
        '平顶山': [113.29, 33.75],
        '邢台': [114.48, 37.05],
        '德州': [116.29, 37.45],
        '济宁': [116.59, 35.38],
        '荆州': [112.239741, 30.335165],
        '宜昌': [111.3, 30.7],
        '义乌': [120.06, 29.32],
        '丽水': [119.92, 28.45],
        '洛阳': [112.44, 34.7],
        '秦皇岛': [119.57, 39.95],
        '株洲': [113.16, 27.83],
        '石家庄': [114.48, 38.03],
        '莱芜': [117.67, 36.19],
        '常德': [111.69, 29.05],
        '保定': [115.48, 38.85],
        '湘潭': [112.91, 27.87],
        '金华': [119.64, 29.12],
        '岳阳': [113.09, 29.37],
        '长沙': [113, 28.21],
        '衢州': [118.88, 28.97],
        '廊坊': [116.7, 39.53],
        '菏泽': [115.480656, 35.23375],
        '合肥': [117.27, 31.86],
        '武汉': [114.31, 30.52],
        '大庆': [125.03, 46.58],
        '泰国': [100.511, 11.252847]
      }
    }
  },
  mounted() {
    this.getDs()
  },
  methods: {
    prt(a, b) {
      console.log('c3.09_chart.' + a, b)
    },
    p11_doClk(iv) {
      if (iv === 41) this.bbViewy = false
    },
    getDs() {
      let url = '/equip/c'
      if (this.bbCust === 'false') {
        url = '/equip/a'
      }
      this.$iPost(url, { iAct: 105 }).then(rs => {
        if (rs.status === 200 && rs.data.stat) {
          rs.data.data.forEach((row, e) => {
            // 0 离线 3连续运行中 5单次运行中 7错误 9已通电 11准备就绪
            if (row.fiv === '1') {
              if (row.fiy === '0') this.qtyStat.push({ name: '离线:' + row.fval, value: row.fval, itemStyle: { color: '#ccc' }, stat: row.fiy })
              if (row.fiy === '3') this.qtyStat.push({ name: '连续运行:' + row.fval, value: row.fval, itemStyle: { color: 'green' }, stat: row.fiy })
              if (row.fiy === '5') this.qtyStat.push({ name: '单次运行:' + row.fval, value: row.fval, itemStyle: { color: 'mediumseagreen' }, stat: row.fiy })
              if (row.fiy === '7') this.qtyStat.push({ name: '异常:' + row.fval, value: row.fval, itemStyle: { color: 'red' }, stat: row.fiy })
              if (row.fiy === '9') this.qtyStat.push({ name: '已通电:' + row.fval, value: row.fval, itemStyle: { color: 'orange' }, stat: row.fiy })
              if (row.fiy === '11') this.qtyStat.push({ name: '准备就绪:' + row.fval, value: row.fval, itemStyle: { color: 'blue' }, stat: row.fiy })
            }
            if (row.fiv === '2') {
              this.qtyCity.push({ name: (row.fiy || '其他') + ':' + row.fval, value: row.fval, itemStyle: { color: '#' + e + '' + e * 7 + '' + e }})// this.qtyCity.push(row)
            }
            if (row.fiv === '3') {
              this.qtyModel.push({ name: row.fiy, value: row.fval })
              this.qtyModel2[0].push((row.fiy || '其他') /** + ':' + row.fval */)
              this.qtyModel2[1].push(row.fval)
            }
          })
          const myRound = echarts.init(document.getElementById('divRound'))
          this.prt('getDs.105.qtyStat', this.qtyStat)
          myRound.setOption(this.mkRound('运行状况...', this.qtyStat))
          myRound.on('click', param => {
            this.vDataStat.forEach(row2 => {
              if (row2.fstat === this.comm.toNum(param.data.stat)) this.vDataCity = row2.data
            })
            this.bbViewy = true
          })
          const myRound2 = echarts.init(document.getElementById('divBar'))
          myRound2.setOption(this.mkRound('区域分布', this.qtyCity))
          const mcBar = echarts.init(document.getElementById('divLine'))
          mcBar.setOption(this.mkBar('规格数量', this.qtyModel2))
        }
      })
      this.$iPost(url, { iAct: 106 }).then(rs => {
        const dtNow = new Date()
        if (rs.status === 200 && rs.data) {
          const vo = this.comm.mkColmns(rs.data.data)
          this.vColms = vo.colms
          this.vCity = []
          this.vDataStat = []
          let idCity = 0
          vo.data.forEach(row => {
            if (row.fid > 0) {
              row['fworktimes'] = this.comm.toNumLocale(row['fworktimes'])
            }
            row['lastTm'] = this.dtUtil.dtDiff(row['last_time'], dtNow, 'ss')
            this.p01_mkStatEquip(row)

            const idxCity = this.vCity.findIndex(row2 => { return row2.name === row.fcity })
            if (idxCity === -1) {
              this.vCity.push({ name: row.fcity, value: idCity++ })
              const obj = {}
              if (row.fstat === 0)obj['off'] = 1
              if (row.fstat === 3)obj['running1'] = 1
              if (row.fstat === 5)obj['running2'] = 1
              if (row.fstat === 7)obj['error'] = 1
              if (row.fstat === 9)obj['on'] = 1
              if (row.fstat === 11)obj['stanby'] = 1
              this.vData.push({ 'city': row.fcity, stat: obj, data: [row] })// {stat:{running:1,error:2}}
            } else {
              const vRow = this.vData[idxCity]
              vRow.data.push(row)
              if (row.fstat === 0) {
                if (vRow.stat.off)vRow.stat.off++
                else vRow.stat.off = 1
              }
              if (row.fstat === 3) {
                if (vRow.stat.running1)vRow.stat.running1++
                else vRow.stat.running1 = 1
              }
              if (row.fstat === 5) {
                if (vRow.stat.running2)vRow.stat.running2++
                else vRow.stat.running2 = 1
              }
              if (row.fstat === 7) {
                if (vRow.stat.error)vRow.stat.error++
                else vRow.stat.error = 1
              }
              if (row.fstat === 9) {
                if (vRow.stat.on)vRow.stat.on++
                else vRow.stat.on = 1
              }
              if (row.fstat === 11) {
                if (vRow.stat.stanby)vRow.stat.stanby++
                else vRow.stat.stanby = 1
              }
              // this.vData[idxCity]['data'].push(row)
            }
            const idxStat = this.vDataStat.findIndex(row2 => {
              return parseInt(row2.fstat) === parseInt(row.fstat)
            })
            if (idxStat === -1) {
              this.vDataStat.push({ fstat: row.fstat, data: [row] })
            } else {
              this.vDataStat[idxStat].data.push(row)
            }
          })
          this.prt('getDs.106.vData', this.vData)
          this.prt('getDs.106.vDataStat', this.vDataStat)
          this.drawMap()
        }
      })
    },
    p01_mkStatEquip(row) {
      // 0 离线 3连续运行中 5单次运行中 7错误 9已通电 11准备就绪
      if (row['lastTm'] > 200) {
        row.fstat = 0
        row.fnamestat = '离线'
      } else {
        if (row.fstatrun === 'true') {
          if (row.fstatcontinuous === 'true') {
            row.fstat = 3
            row.fnamestat = '连续运行'
          } else {
            row.fstat = 5
            row.fnamestat = '单次运行'
          }
        } else {
          if (this.comm.toNum(row.fstaterror) !== 0) {
            row.fstat = 7
            row.fnamestat = '异常'
          } else if (row.fstatinit === 'false') {
            row.fstat = 9
            row.fnamestat = '已通电'
          } else {
            row.fstat = 11
            row.fnamestat = '准备就绪'
          }
        }
      }
    },
    mkRound(pTtl, pData) {
      const opt = {
        title: {
          text: pTtl// ''
        }, /*
        legend: {
          top: '2%',
          orient: 'vertical',
          left: 'left'
        },*/
        series: [
          {
            name: '.',
            type: 'pie',
            radius: ['35%', '75%'],
            avoidLabelOverlap: false,
            itemStyle: {
              borderRadius: 10,
              borderColor: '#fff',
              borderWidth: 2
            },
            label: {
              show: true
              /* position: 'center' */
            },
            data: pData/* [
              { value: 60, name: '待执行生产任务' },
              { value: 90, name: '已完工任务' }
            ]*/
          }
        ]
      }

      return opt
    },
    mkBar(pTtl, pData) {
      const my = this
      // const testDs = [['label', '待开工', '加工中', '已完成'], [99, 999, 88, 888]]
      const option = {
        textStyle: {
          fontSize: 10
        },
        legend: {},
        color: ['#f6da22', '#bbe2e8', '#6cacde'],
        tooltip: {},
        title: { text: pTtl },
        xAxis: {
          type: 'category',
          data: pData[0],
          axisLabel: { interval: 0, rotate: 60 }
          // show: false
        },
        yAxis: {
          type: 'value' /*
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          }*/
        },
        dataset: { source: pData/* testDs*/ },
        series: [
          {
            data: pData[1],
            type: 'bar',
            label: {
              show: true,
              position: 'top'
            },
            itemStyle: {
              normal: {
                // 随机显示
                // color: function(d) { return '#' + Math.floor(Math.random() * (256 * 256 * 256 - 1)).toString(16) }
                // 定制显示（按顺序）
                color: function(params) {
                  return my.colorList[params.dataIndex]
                }
              }
            }
          }
        ]
      }
      this.prt('mkBar.option', option)
      return option
    },
    mkLine() {
      const option = {
        title: {
          text: '生产执行情况'
        },
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          data: ['生产一线', '生产二线', '委外']
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        toolbox: {
          feature: {
            saveAsImage: {}
          }
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: ['溶塑', '成型', '磨平', '抛光', '平整检测', '气密检测', '音频检测']
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            name: '生产一线',
            type: 'line',
            stack: 'Total',
            data: [120, 132, 101, 134, 90, 230, 210]
          },
          {
            name: '生产二线',
            type: 'line',
            stack: 'Total',
            data: [220, 182, 191, 234, 290, 330, 310]
          },
          {
            name: '委外',
            type: 'line',
            stack: 'Total',
            data: [150, 232, 201, 154, 190, 330, 410]
          }
        ]
      }
      return option
    },

    mkOption() {
      /*
      this.vCity = [{
        name: '深圳',
        value: '1'
      },
      {
        name: '河源',
        value: '2'
      },
      {
        name: '惠州',
        value: '3'
      }] */
      this.prt('mkOption.vCity', this.vCity)
      return {
        geo: {
          map: 'china', // 这里的名称需要和 echarts.registerMap('china',{})中的名称一致
          roam: true, // 缩放
          label: { show: false }, // 是否显示省份名称
          zoom: 1.2, // 默认地图在容器中显示zoom:1,可根据需求放大缩小地图
          itemStyle: {
            normal: {
              areaColor: 'rgb(68, 125, 179)', // '#323c48',//'darkblue',//
              borderColor: '#222'
            },
            emphasis: {
              areaColor: '#2a333d',
              show: true
            }
          },
          emphasis: {
            itemStyle: {
              areaColor: 'rgb(68, 125, 179)'
            },
            // 文字颜色，样式在此处
            label: {
              color: 'gold'
            }
          }
        },
        /*
        鼠标移上去时显示悬浮框*/
        tooltip: {
          backgroundColor: '#92DCC6',
          padding: 0,
          trigger: 'item',
          formatter: (param) => {
            // this.prt('mkOption.tooltip.' + param.dataIndex, param.data)
            const vObj = this.vData[param.dataIndex].stat
            return `<div class="pd2mm">
                      <p>连续运行：${vObj.running1 || ''}</p>
                      <p>单次运行：${vObj.running2 || ''}</p>
                      <p>准备就绪：${vObj.stanby || ''}</p>
                      <p>离线：${vObj.off || ''}</p>
                      <p>异常：${vObj.error || ''}</p>
                      <p>已通电：${vObj.on || ''}</p>
                      <p>总：${this.vData[param.dataIndex].data.length}</p>
                    <div>`
          }
        },
        /* 视觉映射组件,有点像legend
        visualMap: [{
          type: 'continuous', // 类型为连续型
          min: 0,
          max: 1000,
          // range: [100, 400],
          left: 'left',
          top: 'bottom',
          text: ['高', '低'], // 取值范围的文字
          textStyle: {
            color: '#fff'
          },
          inRange: {
            color: ['#e0ffff', '#006edd']// 取值范围的颜色
          }
        }],*/

        series: [
          {
            type: 'scatter',
            coordinateSystem: 'geo',
            // type: 'map',
            // map: 'china', // 这里的名称需要和 echarts.registerMap('china',{})中的名称一致
            roam: true, // 缩放
            zoom: 1.2, // 默认地图在容器中显示zoom:1,可根据需求放大缩小地图
            label: {
              show: false, // 是否显示省份名称
              color: 'gold'
            },
            itemStyle: {
              areaColor: 'rgb(68, 125, 179)', // 地图区域背景颜色
              borderColor: '#222', // 地图边界颜色
              emphasis: {
                borderColor: '#fff',
                borderWidth: 1
              }
            },
            emphasis: {
              itemStyle: {
                areaColor: 'rgb(68, 125, 179)'
              },
              // 文字颜色，样式在此处
              label: {
                color: 'gold'
              }
            },
            // 数据
            data: this.rdDs(this.vCity/* dsTest */),
            // 数据映射  同china文件中的name进行映射
            nameMap: {
              '西藏自治区': '西藏',
              '宁夏回族自治区': '宁夏',
              '新疆维吾尔自治区': '新疆'
            }
          },
          {
            type: 'effectScatter',
            coordinateSystem: 'geo',
            data: this.rdDs(this.vCity/* dsTest */),
            symbolSize: 6,
            showEffectOn: 'render',
            rippleEffect: {
              brushType: 'stroke'
            },
            hoverAnimation: true,
            label: {
              normal: {
                formatter: '{b}',
                position: 'right',
                show: true
              }
            },
            itemStyle: {
              normal: {
                color: 'gold', /** #f4e925 */
                shadowBlur: 10,
                shadowColor: '#333'
              }
            },
            zlevel: 1
          }]
      }
    },
    rdDs(data) {
      var res = []
      for (var i = 0; i < data.length; i++) {
        var geoCoord = this.citys[data[i].name]
        if (geoCoord) {
          res.push({
            name: data[i].name,
            value: geoCoord.concat(data[i].value)
          })
        }
      }
      return res
    },
    drawMap() {
      echarts.registerMap('china', china)
      var chinaChart = echarts.init(
        document.getElementById('mapContain')
      )
      chinaChart.setOption(this.mkOption())
      chinaChart.on('click', param => {
        this.prt('drawMap.vData', this.vData)
        this.vDataCity = this.vData[param.dataIndex].data
        this.bbViewy = true
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/comps/c3_tools/09_chart.vue